

function Display(props){
return <h5>{props.display}</h5>
}


export default Display